// Smart Digi brand logo
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_led-web-platform/artifacts/qmt8sixh_image.png";

const heights = {
  sm: "h-8",
  md: "h-11",
  lg: "h-14",
  xl: "h-16",
};

export const Logo = ({ size = "md", variant = "dark", className = "" }) => {
  const h = heights[size] || heights.md;
  const img = (
    <img
      src={LOGO_URL}
      alt="Smart Digi — Digital Brilliance by Design"
      className={`${h} w-auto object-contain select-none`}
      draggable={false}
      decoding="async"
      loading="eager"
      style={{ imageRendering: "-webkit-optimize-contrast" }}
    />
  );

  if (variant === "light") {
    return (
      <div className={`inline-flex bg-white px-3 py-2 rounded-md ${className}`}>{img}</div>
    );
  }
  return <div className={`inline-flex ${className}`}>{img}</div>;
};

export default Logo;
